export default __webpack_public_path__ + "static/media/Stage3_correct.3dcf1b72.svg";